<template>
  <div
    v-if="shouldRenderConfig && showCustomFormat"
    class="matrix_pageOptionAttributes"
  >
    <div class="matrix_inpuCustomFormatCotainer">
      <div class="matrix_inpuCustomFormatLabel">
        {{ $t("Custom format:") }}
      </div>
      <div class="matrix_inpuCustomFormatItems">
        <div class="matrix_inpuCustomFormatItem">
          <!-- <div class="matrix_inpuCustomFormatItemLabel">{{ $t('Width:') }}</div> -->
          <input
            v-model="width"
            type="text"
            :placeholder="$t('Width:')"
            @keydown.enter="onEnter"
          />
        </div>
        <div class="matrix_inpuCustomFormatItem">
          <!-- <div class="matrix_inpuCustomFormatItemLabel">{{ $t('Height:') }}</div> -->
          <input
            v-model="height"
            type="text"
            :placeholder="$t('Height:')"
            @keydown.enter="onEnter"
          />
        </div>
      </div>
      <button
        type="button"
        class="btn btn-primary"
        @click="onClickInputCustomFormat()"
      >
        {{ $t("Create format") }}
      </button>
    </div>
  </div>
</template>
<script>
import { useCustomStore } from "@/stores/modules/custom";

import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

import { i18n } from "../../i18n.js";

export default {
  computed: {
    ...mapState(useCustomStore, ["getCustomFormatLimits"]),
    ...mapState(useWebproductStore, [
      "getActiveProductPageOptions",
      "getProductPageOptionsForCode"
    ]),
    showCustomFormat: function () {
      const formatPo = this.getProductPageOptionsForCode({
        code: this.ppcode,
        all: false
      });
      if (formatPo && formatPo["format"]) {
        if (formatPo["format"].values.length < 2) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    ...mapActions(useCustomStore, ["setCustomFormat", "inputCustomFormat"]),
    onEnter: function (event) {
      event.preventDefault();
    },
    onClickInputCustomFormat: function (event) {
      this.inputCustomFormat({
        width: this.width,
        height: this.height,
        widget: this
      });
    } /*
    validateInput(value, label, min, max) {
      value = value.replace(",", ".");
      if (value == "") {
        return { valid: false, msg: i18n.t("Please input " + label + "!") };
      }
      if (isNaN(value)) {
        return { valid: false, msg: i18n.t(label + " must be a number!") };
      }
      if (parseFloat(value) < min) {
        return {
          valid: false,
          msg: i18n.t("Width must be greater than") + " " + min
        };
      }
      if (parseFloat(value) > max) {
        return {
          valid: false,
          msg: i18n.t(label + " must be smaller than") + " " + max
        };
      }
      return { valid: true, msg: "", number: parseFloat(value) };
    }*/
  },
  props: ["showFormats", "ppcode"],
  data: function () {
    return {
      width: "",
      height: ""
    };
  }
};
</script>
